import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export interface MultiSelectFilterOption<T> {
    value: T;
    label: string;
}

@Component({
    selector: 'app-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    imports: [TranslatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MultiSelectFilterComponent<T> {
    public label = input.required<string>();
    public optionTranslationPrefix = input<string>('');
    public options = input.required<MultiSelectFilterOption<T>[]>();
    public targetId = input<string>('');
    public value = input<T[]>([]);

    public valueChange = output<T[]>();

    protected selectedValues = this.value;

    protected toggleItem(value: T): void {
        const currentSelected = this.selectedValues();
        let newSelected: T[];

        const index = currentSelected.findIndex((v) => this.valuesEqual(v, value));
        if (index > -1) {
            newSelected = currentSelected.filter((_, i) => i !== index);
        } else {
            newSelected = [...currentSelected, value];
        }

        this.valueChange.emit(newSelected);
    }

    protected isOptionActive(optionValue: T): boolean {
        return this.selectedValues().some((v) => this.valuesEqual(v, optionValue));
    }

    private valuesEqual(a: T, b: T): boolean {
        if (a === b) return true;
        if (typeof a === 'object' && typeof b === 'object' && a !== null && b !== null) {
            return JSON.stringify(a) === JSON.stringify(b);
        }
        return false;
    }
}
